import { FALLBACK_AFTER_S, type VerifyState } from '@/lib/useVerifyStatus'
import styles from '@/pages/AuthPage.module.css'

/**
 * Подсказки под клетками кода при мобильной авторизации: откуда придёт код, и кнопка
 * «не приходит» — перевести проверку на SMS от Кличата. Оператор может пообещать SMS
 * и не прислать, а по статусу это не отличить от «код в пути», так что решает человек.
 */
export function CodeFallback({ state }: { state: VerifyState }) {
  if (!state.mobile) return null
  if (state.channel === 'sms') {
    return <p className={styles.muted}>Оператор код не доставил — отправили SMS от Кличата, в нём шесть цифр.</p>
  }
  if (state.elapsed < FALLBACK_AFTER_S) return null
  return (
    <p className={styles.muted}>
      Не приходит код?{' '}
      <button type="button" className={styles.link} onClick={state.forceSMS} disabled={state.forcing}>
        {state.forcing ? 'Отправляем…' : 'Отправить SMS от Кличата'}
      </button>
      {state.forceError ? <span className={styles.error}> {state.forceError}</span> : null}
    </p>
  )
}
